<template>
  <div>
    <el-menu :default-active="active_path" class="el-menu-vertical-demo" background-color="#112f50" text-color="#fff"
      active-text-color="#ffd04b" router :collapse="isCollapse">
      <el-menu-item>

        <span slot="title">金宸后台管理系统</span>
      </el-menu-item>
      <el-menu-item index="/">
        <i class="el-icon-menu"></i>
        <span slot="title">首页</span>
      </el-menu-item>

      <el-submenu index="/register">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>注册</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/register/register-list1">
            <i class="el-icon-location"></i>
            <span>老系统注册</span>
          </el-menu-item>
          <el-menu-item index="/register/cardmachinerecord-list">
            <i class="el-icon-location"></i>
            <span>发卡机注册</span>
          </el-menu-item>
          <el-menu-item index="/register/register-price">
            <i class="el-icon-location"></i>
            <span>注册价格设置</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="/cardmachine">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>发卡机管理</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/cardmachine/cardmachine-list">
            <i class="el-icon-location"></i>
            <span>发卡机列表</span>
          </el-menu-item>
          <el-menu-item index="/cardmachine/collect">
            <i class="el-icon-location"></i>
            <span>订单汇总</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="/m4system">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>M4软件</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/m4system/m4system-list">
            <i class="el-icon-location"></i>
            <span>软件房间备份</span>
          </el-menu-item>
          <el-menu-item index="/m4system/m4system-price">
            <i class="el-icon-location"></i>
            <span>软件房间价格设置</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="/application">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>APP</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/application/appaccount-list">
            <i class="el-icon-location"></i>
            <span>用户列表</span>
          </el-menu-item>
          <el-menu-item index="/application/applock-list">
            <i class="el-icon-location"></i>
            <span>密码锁列表</span>
          </el-menu-item>

        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="/goods">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>商品管理</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/goods/goods-list">
            <i class="el-icon-location"></i>
            <span>商品列表</span>
          </el-menu-item>

        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="/order">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>订单管理</span>
        </template>
        <el-menu-item-group>

          <el-menu-item index="/order/order-goodslist">
            <i class="el-icon-location"></i>
            <span>商品订单</span>
          </el-menu-item>

        </el-menu-item-group>
      </el-submenu>
    </el-menu>

  </div>
</template>

<script>


export default {
  data() {
    return {
      isCollapse: false,
      active_path: ''
    }
  },
  created() {
    if (this.$route.meta.activeMenu) {
      this.active_path = this.$route.meta.activeMenu
    }
    else {
      this.active_path = this.$route.path
    }
  },
  watch: {
    $route(to, from) {
      let { meta, path } = to
      if (meta.activeMenu) {
        this.active_path = meta.activeMenu
      }
      else {
        this.active_path = path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;

}
</style>